export enum VoteChangeAction {
  SET = "SET",
  REMOVE = "REMOVE",
}

export type VoteChangeModel = {
  action: VoteChangeAction;
  gameId: string;
  userId: string;
};
